import { render, staticRenderFns } from "./ProviderCard.vue?vue&type=template&id=51c38747&scoped=true"
import script from "./ProviderCard.vue?vue&type=script&lang=js"
export * from "./ProviderCard.vue?vue&type=script&lang=js"
import style0 from "./ProviderCard.vue?vue&type=style&index=0&id=51c38747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c38747",
  null
  
)

export default component.exports